import DOMPurify from 'dompurify';

/**
 * Sanitizes a string to prevent XSS attacks
 * @param input The string to sanitize
 * @returns The sanitized string
 */
const SanitizeText = ({input='',onlyHtml= false,replaceSpaceWhitespace=true}): string | undefined => {
  if (input=='') return undefined;
  // Use DOMPurify to sanitize the string and strip any HTML/script tags
  let sanitized = DOMPurify.sanitize(input, { RETURN_DOM_FRAGMENT: false, RETURN_DOM: false });
  
  if(!onlyHtml){
  // Escape any special characters that could be used for XSS
  sanitized= sanitized.replace(/[<>'"\\]/g, char => {
    switch (char) {
      case '<':
        return '&lt;';
      case '>':
        return '&gt;';
      case '"':
        return '&quot;';
      case "'":
        return '&#39;';
      case '\\':
        return '&#92;';
      default:
        return char;
    }
  });
  if(replaceSpaceWhitespace){
    sanitized=sanitized.replaceAll(' ','+');
  }
}
return sanitized;
};

export default SanitizeText;